import type { StreamDataColumn } from '@squaredup/data-streams';
import Field from 'components/forms/field/Field';
import { Controller } from 'react-hook-form';
import { FormatExpressionEditor } from '../FormatExpressionEditor';

interface ValueExpressionFieldProps {
    columnName: string;
    columns: StreamDataColumn[];
}

export const ValueExpressionField: React.FC<ValueExpressionFieldProps> = ({ columns }) => (
    <div className='max-w-4xl'>
        <Field.Label 
            label='Value' 
            tooltipAlign='Left' 
            help='Provide an expression used to compute the value of this column. [Learn more](https://docs.squaredup.com/first-steps/tile-editor#custom-columns)'
        >
            <Controller
                name='valueExpression'
                render={({ field: { value, onChange } }) => (
                    <FormatExpressionEditor
                        showHint
                        name='valueExpression'
                        value={value || ''}
                        onChange={onChange}
                        columns={columns}
                    />
                )}
            />
        </Field.Label>
    </div>
);
